import React from 'react'
import RootWrapper from '@/components/RootWrapper'

export const wrapRootElement = ({ element }) => <RootWrapper>{element}</RootWrapper>

export const onServiceWorkerUpdateReady = () => {
  window.location.reload()
}

// Scripts that runs when the app loads
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {

    // СookieBot
    const script = document.createElement('script')
    script.id = 'Cookiebot'
    script.src = 'https://consent.cookiebot.com/uc.js'
    script.setAttribute('data-cbid', '04846584-862b-44ca-b53d-7661d6e4e969')
    script.setAttribute('data-blockingmode', 'auto')
    script.type = 'text/javascript'
    document.head.appendChild(script)

    const loadSnoobi = () => {
      if (!(window.Cookiebot?.consent?.statistics || window.Cookiebot?.consent?.marketing)) {
        return
      }
      if (document.getElementById('Snoobi')) {
        return
      }

      // Snoobi analytics
      const snoobiScript = document.createElement('script')
      snoobiScript.id = 'Snoobi'
      snoobiScript.type = 'text/javascript'
      snoobiScript.async = true
      const account = 'tkl_fi'
      const pageName = ''
      const section = ''
      const anchors = '1'
      const cookies = 'session'
      snoobiScript.src =
        (document.location.protocol === 'https:' ? 'https://' : 'http://') +
        'eu2.snoobi.com/?account=' + encodeURIComponent(account) +
        '&page_name=' + encodeURIComponent(pageName) +
        '&section=' + encodeURIComponent(section) +
        '&anchors=' + encodeURIComponent(anchors) +
        '&cookies=' + encodeURIComponent(cookies)
      document.head.appendChild(snoobiScript)
    }

    window.addEventListener('CookiebotOnConsentReady', loadSnoobi)
    window.addEventListener('CookiebotOnAccept', loadSnoobi)
    loadSnoobi()
  }
}
